import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { BsPlus } from 'react-icons/bs';

import { Text, Alerts, Button, WrapperFlex } from '@unimed-fesp/components';

// #region import componentes
import FadeIn from '../../atoms/FadeIn';
import ModalError from '../ModalError';
import ModalSuccess from '../ModalSuccess';
import ModalCancelAction from '../ModalCancelAction';
import DropDownSearchBox from '../DropDownSearchBox';
import CustomScrollBars from '../../molecules/CustomScrollBars';
import ModalConsultaContratantes from '../ModalConsultaContratantes';

import ParametrizacaoCards from './ParametrizacaoCards';
import EmptyContentContainer from './EmptyContentContainer';
// #endregion

import { AlertList } from './styles';
import theme from '../../../styles/theme';

import { setParametrizacaoNivel } from '../../../utils/treeViewBuilder';
import { TipoConsultaParametrizacaoEnum, TipoCardRoot } from '../../../enums';

import { Creators as UsuarioActions } from '../../../store/ducks/usuario';
import { Creators as ContratanteActions } from '../../../store/ducks/contratante';

import useParametrizacao from '../../../hooks/useParametrizazao';

const ParametrizacaoContratantes = ({
  idUsuario,
  dropDownWidth,
  roleUsuario = null,
}) => {
  const dispatch = useDispatch();

  const {
    handleAdicionarModal,
    parametrizacaoRoot,
    selectedUser,
    handleCheckUser,
    handleOnClickSalvarCard,

    handleRemoveCard,
    paginationModalParams,
    rowsChecked,
    setTipoBusca,
    setRowsChecked,
    getContratantes,
    cleanFilterParams,
    tableFilterparams,
    getGrupoComplementos,
    setTableFilterParams,
    paginationParams,
    setPaginationParams,
    parametrizacaoFilterParams,
    setParametrizacaoFilterParams,
  } = useParametrizacao(idUsuario, roleUsuario);

  const {
    saveParametrizacaoCards,
    getAndBuildParametrizacaoCards,
  } = useSelector((state) => state.usuario);

  const [blockUseEffect, setBlockUseEffect] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState({
    success: false,
    message: '',
    alert: false,
  });
  const [isError, setIsError] = useState({ error: false, message: '' });
  const [isWarning, setIsWarning] = useState({
    warning: false,
    message: '',
    action: (_) => _,
  });

  const handleModalSuccess = () => {
    setBlockUseEffect(false);
    setIsSuccess({ success: false, message: '' });
    dispatch(UsuarioActions.parametrizacaoNodeRenew());
  };

  const handleModalError = () => {
    setIsError({ error: false, message: '' });
    dispatch(UsuarioActions.parametrizacaoNodeRenew());
  };

  const handleModalCancelAction = (idCard, idParametrizacao) => {
    setIsWarning({
      warning: !isWarning.warning,
      message: 'Deseja realmente excluir esta parametrização?',
      action: () => {
        handleRemoveCard(idCard, idParametrizacao);
        setIsWarning({
          warning: false,
          message: '',
          action: (_) => _,
        });
      },
    });
  };

  const handleToogleModal = (e) => {
    if (e.keyCode !== 13) {
      cleanFilterParams();
      setIsOpen(!isOpen);
    }
  };

  function handleOnClickEditar(idCard) {
    const card = parametrizacaoRoot.find(
      (cardItem) => cardItem.idCard === idCard
    );
    if (isEmpty(card.options) && card.idParametrizacao === 0) {
      if (
        card.tipoParametrizacao === TipoConsultaParametrizacaoEnum.returnName[1]
      ) {
        dispatch(
          ContratanteActions.getGrupoContratantesRequest({
            codigoGrupo: card?.complemento?.codigoGrupo,
            codigoComplemento: card?.complemento?.codigoComplemento,
            idCard,
            path: [0],
          })
        );
      } else {
        dispatch(
          ContratanteActions.getContratanteModalidadesRequest({
            codigoContratante: card.contratante?.codigoContratante,
            idCard,
            path: [0],
          })
        );
      }
    }

    if (card.idParametrizacao !== 0 && !card?.fullTree) {
      dispatch(
        UsuarioActions.getParametrizacaoCardsCompletoRequest(
          idUsuario,
          idCard,
          card.idParametrizacao
        )
      );
    }

    handleToogleCard(idCard);
  }

  function handleToogleCard(idCard) {
    dispatch(ContratanteActions.parametrizacaoToogleCard([{ idCard }]));
  }

  function handleSearchTable(e, isOnClick = false) {
    if (e.keyCode === 13 || isOnClick) {
      setPaginationParams(paginationModalParams);
      handleCheckUser(null);
      dispatch(
        setTipoBusca(
          tableFilterparams.tipoParametrizacao,
          paginationModalParams
        )
      );
    }
  }

  const setTipoContagemRequest = (tipoNode, parametrizacao) => {
    const tipoNodes = {
      Contratante: {
        contratante: {
          codigoContratante: parametrizacao?.contratante?.codigoContratante,
        },
        idCard: parametrizacao.idCard,
      },
      [TipoConsultaParametrizacaoEnum.returnName[1]]: {
        complemento: {
          codigoGrupo: parametrizacao?.complemento?.codigoGrupo,
          codigoComplemento: parametrizacao?.complemento?.codigoComplemento,
        },
        idCard: parametrizacao.idCard,
      },
    };

    return tipoNodes[tipoNode];
  };

  const handleFilterParametrizacaoRoot = (selCard) => {
    if (
      parametrizacaoFilterParams.tipoParametrizacao ===
      TipoConsultaParametrizacaoEnum.returnNameFormatted[0]
    )
      return (
        setParametrizacaoNivel(
          selCard.tipoParametrizacao,
          selCard
        ).nome.includes(
          parametrizacaoFilterParams.buscaParametrizacao.toUpperCase()
        ) ||
        !!selCard.options[0]?.subOptions?.find((c) =>
          c.name.includes(
            parametrizacaoFilterParams.buscaParametrizacao.toUpperCase()
          )
        )
      );

    if (
      parametrizacaoFilterParams.tipoParametrizacao ===
      TipoConsultaParametrizacaoEnum.returnNameFormatted[1]
    )
      return (
        selCard.tipoParametrizacao ===
          TipoConsultaParametrizacaoEnum.returnNameFormatted[1] &&
        (setParametrizacaoNivel(
          selCard.tipoParametrizacao,
          selCard
        ).nome.includes(
          parametrizacaoFilterParams.buscaParametrizacao.toUpperCase()
        ) ||
          !!selCard.options[0]?.subOptions?.find((c) =>
            c.name.includes(
              parametrizacaoFilterParams.buscaParametrizacao.toUpperCase()
            )
          ))
      );

    if (
      parametrizacaoFilterParams.tipoParametrizacao ===
      TipoConsultaParametrizacaoEnum.returnNameFormatted[2]
    )
      return (
        setParametrizacaoNivel(
          selCard.tipoParametrizacao,
          selCard
        ).nome.includes(
          parametrizacaoFilterParams.buscaParametrizacao.toUpperCase()
        ) &&
        selCard.tipoParametrizacao ===
          TipoConsultaParametrizacaoEnum.returnNameFormatted[2]
      );
    return false;
  };

  useEffect(() => {
    dispatch(ContratanteActions.parametrizacaoRootRenew());
    if (idUsuario) {
      const params = { idUsuario };

      dispatch(UsuarioActions.getAndBuildParametrizacaoCardsRequest(params));
    }
  }, [dispatch, idUsuario]);

  useEffect(() => {
    if (idUsuario > 0) {
      if (
        saveParametrizacaoCards.success &&
        !saveParametrizacaoCards.hasValidationErrors &&
        roleUsuario?.toLocaleUpperCase() !== 'ADM'
      ) {
        setIsSuccess({
          success: true,
          message: { title: 'Parametrização salva com sucesso!', subtitle: '' },
          alert: false,
        });
      } else if (
        saveParametrizacaoCards.success &&
        saveParametrizacaoCards.hasValidationErrors
      ) {
        setIsSuccess({
          success: true,
          message: {
            title: 'Parametrização salva com sucesso!',
            subtitle: saveParametrizacaoCards.error,
          },
          alert: true,
        });
      }
    }
  }, [
    idUsuario,
    roleUsuario,
    saveParametrizacaoCards.error,
    saveParametrizacaoCards.hasValidationErrors,
    saveParametrizacaoCards.success,
  ]);

  useEffect(() => {
    if (idUsuario > 0 && saveParametrizacaoCards.isError) {
      setIsError({
        error: true,
        message:
          saveParametrizacaoCards.error[0] || 'Erro ao salvar a parametrização',
      });
    }
  }, [
    idUsuario,
    saveParametrizacaoCards.error,
    saveParametrizacaoCards.isError,
  ]);

  useEffect(() => {
    if (idUsuario > 0 && saveParametrizacaoCards.success && !blockUseEffect) {
      const grupoContagem = [];
      const contratanteContagem = [];
      const cardParametrizado = [];
      saveParametrizacaoCards.response.forEach((p) => {
        const newCard = parametrizacaoRoot.find((c) => c.idCard === p.idCard);
        if (newCard) cardParametrizado.push(newCard);
      });

      cardParametrizado.forEach((card) => {
        if (TipoCardRoot.returnName[0] === card.tipoParametrizacao)
          contratanteContagem.push(
            setTipoContagemRequest(card.tipoParametrizacao, card)
          );
        if (TipoCardRoot.returnName[1] === card.tipoParametrizacao)
          grupoContagem.push(
            setTipoContagemRequest(card.tipoParametrizacao, card)
          );
      });
      dispatch(
        UsuarioActions.getParametrizacaoCardsRequest({ idUsuario }, [
          ...grupoContagem,
          ...contratanteContagem,
        ])
      );

      dispatch(
        ContratanteActions.parametrizacaoSetLoadingCards(true, [
          ...grupoContagem,
          ...contratanteContagem,
        ])
      );
      setBlockUseEffect(true);
    }
  }, [
    dispatch,
    idUsuario,
    blockUseEffect,
    parametrizacaoRoot,
    saveParametrizacaoCards.response,
    saveParametrizacaoCards.success,
  ]);

  return (
    <>
      <WrapperFlex column justifyCenter alignCenter>
        <FadeIn width="100%">
          <WrapperFlex column justifyCenter alignStart>
            <Text
              text="Contratantes"
              type="headlineOne"
              font="bold 16px/14px Calibri"
              color={theme.greenDefault}
            >
              resultados de consulta
            </Text>
            <WrapperFlex
              marginTop={25}
              fullWidth
              justifySpaceBetween
              alignStart
            >
              <DropDownSearchBox
                dropdownName="tipoParametrizacao"
                inputName="buscaParametrizacao"
                params={parametrizacaoFilterParams}
                setParams={setParametrizacaoFilterParams}
                options={TipoConsultaParametrizacaoEnum.returnNameFormatted}
                inputWidth="524"
                width={dropDownWidth}
                placeholder={(() => {
                  if (
                    parametrizacaoFilterParams.tipoParametrizacao ===
                    TipoConsultaParametrizacaoEnum.returnNameFormatted[0]
                  )
                    return 'Digite o código do grupo, complemento ou nome da contratante';
                  if (
                    parametrizacaoFilterParams.tipoParametrizacao ===
                    TipoConsultaParametrizacaoEnum.returnName[1]
                  )
                    return 'Digite o código do grupo ou complemento';
                  return 'Digite o código ou nome de contratante';
                })()}
                marginRight="30"
              />
              <Button
                tipo="primary"
                paddingTop={10}
                paddingRight={10}
                paddingBottom={10}
                paddingLeft={10}
                justifySpaceBetween
                alignCenter
                width={138}
                type="button"
                font="16px unimed_slabregular"
                onClick={(e) => handleToogleModal(e)}
                data-testid="btn-add-contratante"
              >
                <BsPlus color="#FFFF" size="20" />
                parâmetros
              </Button>
            </WrapperFlex>
            {isEmpty(parametrizacaoRoot) ? (
              <EmptyContentContainer
                display=""
                marginTop="28px"
                onClick={(e) => handleToogleModal(e)}
                loading={getAndBuildParametrizacaoCards.loading}
              />
            ) : (
              Object.values(parametrizacaoRoot)
                .filter((selCard) => handleFilterParametrizacaoRoot(selCard))
                .map((selectedCard) => {
                  return (
                    <FadeIn width="100%" key={selectedCard.id}>
                      <ParametrizacaoCards
                        idUsuario={idUsuario}
                        selectedCard={selectedCard}
                        handleOnClickEditar={handleOnClickEditar}
                        handleOnClickSalvar={handleOnClickSalvarCard}
                        handleToogleCard={handleToogleCard}
                        handleModalCancelAction={handleModalCancelAction}
                      />
                    </FadeIn>
                  );
                })
            )}
          </WrapperFlex>
        </FadeIn>
      </WrapperFlex>
      <ModalConsultaContratantes
        isOpen={isOpen}
        params={tableFilterparams}
        setParams={setTableFilterParams}
        grupoComplementosParams={getGrupoComplementos}
        contratanteParams={getContratantes}
        rowsChecked={rowsChecked}
        setRowsChecked={setRowsChecked}
        paginationParams={paginationParams}
        setPaginationParams={setPaginationParams}
        setTipoBusca={setTipoBusca}
        onClick={handleToogleModal}
        handleSearchTable={handleSearchTable}
        handleAdicionarModal={handleAdicionarModal}
        handleCheckUser={handleCheckUser}
        selectedUser={selectedUser}
      />
      <ModalSuccess
        onClick={handleModalSuccess}
        text={isSuccess.message.title}
        isOpen={isSuccess.success}
        alert={
          isSuccess.alert ? (
            <Alerts width={328} type="warning">
              <span>
                <WrapperFlex column alignCenter marginSides={0}>
                  <b>Atenção!</b>
                  <b>Erro ao salvar parametrização: </b>
                  <CustomScrollBars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                    autoHeight
                    autoHeightMin={0}
                    autoHeightMax={60}
                    thumbMinSize={30}
                    universal
                  >
                    <AlertList>
                      {isSuccess.message.subtitle.map((sub) => (
                        <li key={`${sub.name}-${sub.errorMessage}`}>
                          <b>{sub.name}</b> - {sub.errorMessage}
                        </li>
                      ))}
                    </AlertList>
                  </CustomScrollBars>
                </WrapperFlex>
              </span>
            </Alerts>
          ) : (
            false
          )
        }
      />
      <ModalError
        onClick={handleModalError}
        text={isError.message || 'Erro ao salvar a parametrização.'}
        isOpen={isError.error}
      />
      <ModalCancelAction
        onClick={handleModalCancelAction}
        onClickOk={isWarning.action}
        isOpen={isWarning.warning}
        text={isWarning.message}
        textHeader="cancelar"
      />
    </>
  );
};

export default ParametrizacaoContratantes;
